import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { PlAN_TYPES } from '../../../constants/individualPortal/customGrouping/customGrouping.constants';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    typeOfPlan: PlAN_TYPES
}

export default function ChangeApplicationNotToConsiderModal({ closeModal, typeOfPlan }: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        closeModal('changeApplicationNotToConsider');
    }

    return (
        <Modal id="changeApplicationNotToConsiderModal">
            <Modal.Header id="changeApplicationNotToConsiderModalHeader" titleId="customGrouping.customGrouping" onHide={onClose} />
            <Modal.Body id="changeApplicationNotToConsiderModalBody">
                <p>
                    <FormattedMessage id={`customGrouping.notConsider.${typeOfPlan}`} />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton
                    id="changeApplicationNotToConsiderModalCancelButton"
                    onClickHandler={onClose}
                    variant="secondary"
                    labelId="button.cancel"
                />
                <CapitalizedButton
                    id="changeApplicationNotToConsiderModalOkButton"
                    onClickHandler={onClose}
                    variant="primary"
                    labelId="button.ok"
                    leftMargin={true}
                />
            </Modal.Controls>
        </Modal>
    );
}
